/**
 * Tipos para o sistema de internacionalização (i18n)
 * 
 * Define os idiomas suportados e estrutura de recursos de tradução.
 */

// Códigos de idiomas suportados
export type SupportedLanguage = 'pt-BR' | 'en-US' | 'es-ES';

// Configuração de idioma para exibição
export interface LanguageConfig {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
  flag: string;
}

// Lista de idiomas disponíveis
export const SUPPORTED_LANGUAGES: LanguageConfig[] = [
  { code: 'pt-BR', name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷' },
  { code: 'en-US', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'es-ES', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
];

// Idioma padrão (fallback)
export const DEFAULT_LANGUAGE: SupportedLanguage = 'pt-BR';

// Namespaces de tradução disponíveis
export type TranslationNamespace = 'common' | 'sidebar' | 'auth' | 'pages' | 'help';

// Chave para armazenamento no localStorage
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';
